import React from 'react'
import styled from 'styled-components/native'
import I18n from 'APP/I18n'
import IconCard from 'APP/Converse/IconCard'

const StyledNotice = styled(IconCard)`
  background-color: ${({ theme }) => theme.colors.selected};
`

export const CardholderNotice = () => (
  <StyledNotice
    testID="CARDHOLDER_NOTICE"
    description={I18n.t('Checkout.PaymentMethods.cardholderNotice')}
    leftIcon={{
      src: 'info-outline',
      variant: 'materialIcons',
      color: 'text',
    }}
  />
)

export default CardholderNotice
